export const ProcessingWorkOrdersService = {
  getData() {
    return [
      {
        businessProcessName: 'Монтаж оборудования',
        description: 'Монтаж и настройка оборудования на объекте',
        id: 1000,
        taskStatuses: [
          {
            id: 10000,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Устранение неполадок',
        description: 'Устранение неполадок в кабельной сети',
        id: 1001,
        taskStatuses: [
          {
            id: 10010,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Ремонт вышки',
        description: 'Ремонт вышки в связи с обрывом кабеля',
        id: 1002,
        taskStatuses: [
          {
            id: 10020,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение клиента',
        description: 'Подключение нового абонента к сети',
        id: 1003,
        taskStatuses: [
          {
            id: 10030,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Установка программного обеспечения',
        description: 'Установка ПО',
        id: 1004,
        taskStatuses: [
          {
            id: 10040,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Устранение неполадок на линии',
        description:
          'Установка нового программного обеспечения на устройство абонента',
        id: 1005,
        taskStatuses: [
          {
            id: 10050,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Обрыв кабеля',
        description: 'Устранение обрыва кабеля',
        id: 1006,
        taskStatuses: [
          {
            id: 10060,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Увеличение мощности',
        description: 'Увеличение мощности',
        id: 1007,
        taskStatuses: [
          {
            id: 10070,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 1 ',
        description: 'Подключение 1  Описание',
        id: 1008,
        taskStatuses: [
          {
            id: 10080,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 2',
        description: 'Подключение 2 Описание',
        id: 1009,
        taskStatuses: [
          {
            id: 10090,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 3',
        description: 'Подключение 3 Описание',
        id: 1010,
        taskStatuses: [
          {
            id: 10100,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 4',
        description: 'Подключение 4 Описание',
        id: 1011,
        taskStatuses: [
          {
            id: 10110,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 5',
        description: 'Подключение 5 Описание',
        id: 1012,
        taskStatuses: [
          {
            id: 10120,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 6',
        description: 'Подключение 6 Описание',
        id: 1013,
        taskStatuses: [
          {
            id: 10130,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 7',
        description: 'Подключение 7 Описание',
        id: 1014,
        taskStatuses: [
          {
            id: 10140,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 8',
        description: 'Подключение 8 Описание',
        id: 1015,
        taskStatuses: [
          {
            id: 10150,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 9',
        description: 'Подключение 9 Описание',
        id: 1016,
        taskStatuses: [
          {
            id: 10160,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 10',
        description: 'Подключение 10 Описание',
        id: 1017,
        taskStatuses: [
          {
            id: 10170,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 11',
        description: 'Подключение 11 Описание',
        id: 1018,
        taskStatuses: [
          {
            id: 10180,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 12',
        description: 'Подключение 12 Описание',
        id: 1019,
        taskStatuses: [
          {
            id: 10190,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 13',
        description: 'Подключение 13 Описание',
        id: 1020,
        taskStatuses: [
          {
            id: 10200,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 14',
        description: 'Подключение 14 Описание',
        id: 1021,
        taskStatuses: [
          {
            id: 10210,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 15',
        description: 'Подключение 15 Описание',
        id: 1022,
        taskStatuses: [
          {
            id: 10220,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 16',
        description: 'Подключение 16 Описание',
        id: 1023,
        taskStatuses: [
          {
            id: 10230,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 17',
        description: 'Подключение 17 Описание',
        id: 1024,
        taskStatuses: [
          {
            id: 10240,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 18',
        description: 'Подключение 18 Описание',
        id: 1025,
        taskStatuses: [
          {
            id: 10250,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 19',
        description: 'Подключение 19 Описание',
        id: 1026,
        taskStatuses: [
          {
            id: 10260,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 20',
        description: 'Подключение 20 Описание',
        id: 1027,
        taskStatuses: [
          {
            id: 10270,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 21',
        description: 'Подключение 21 Описание',
        id: 1028,
        taskStatuses: [
          {
            id: 10280,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 22',
        description: 'Подключение 22 Описание',
        id: 1029,
        taskStatuses: [
          {
            id: 10290,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      },
      {
        businessProcessName: 'Подключение к сети 23',
        description: 'Подключение 23 Описание',
        id: 1030,
        taskStatuses: [
          {
            id: 10300,
            actionName: '',
            statusBefore: null,
            statusAfter: null,
            roles: [],
            priority: null,
            fieldFilling: []
          }
        ]
      }
    ];
  },

  getProcessingWorkOrders() {
    return Promise.resolve(this.getData());
  }
};
